import { render, staticRenderFns } from "./GoalArea.vue?vue&type=template&id=9f688b5a&scoped=true&"
import script from "./GoalArea.vue?vue&type=script&lang=js&"
export * from "./GoalArea.vue?vue&type=script&lang=js&"
import style0 from "./GoalArea.vue?vue&type=style&index=0&id=9f688b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f688b5a",
  null
  
)

export default component.exports